import { useTranslation } from 'react-i18next';

import IconMore from 'approot/shared/icons/icon-more';
import { ACTIVITY_BUILDER_MORE_MENU_CONTAINER } from '../activity-builder.constants';
import * as Styled from '../settings/settings-drawer.style';
import { Dropdown } from 'approot/shared/dropdown/dropdown';
import { DropdownItem } from 'approot/shared/dropdown/dropdown-item.style';
import Spinner from 'approot/shared/spinner/spinner';
import useExportProgram from 'approot/unit/export-program/export-program.hooks';
import { useSnackbar } from 'approot/shared/snackbar-notification/snackbar-notification.hooks';
import { NAMESPACE_TRANSLATION } from 'internationalise';
import { getUnitProgramLabel } from 'approot/shared/logic/content-label';

const ActivityBuilderDownloadDropdown = ({
  unitId,
  unitName,
  onClickEmailActivities,
}: {
  unitId: number;
  unitName: string;
  onClickEmailActivities: () => void;
}) => {
  const { showSuccess, showError } = useSnackbar();
  const { t } = useTranslation(NAMESPACE_TRANSLATION);
  const programLabel = getUnitProgramLabel(t);

  const { handleExportProgram, isLoading } = useExportProgram({
    unitId,
    unitName,
    onSuccess: () => {
      showSuccess(`Your ${programLabel} has been downloaded.`);
    },
    onError: () => {
      showError(
        `An error occurred downloading the ${programLabel}. Please try again.`
      );
    },
  });

  return (
    <Dropdown
      menuWidth={250}
      aria-label="More options for downloading activities"
      menuContainerElement={ACTIVITY_BUILDER_MORE_MENU_CONTAINER}
      borderRadius={4}
      closeMenuOnSelect={false}
      data-selector="lb-more-btn"
      dropdownContents={
        <>
          <DropdownItem
            data-selector="lb-drawer-lesson-download-btn"
            onClick={onClickEmailActivities}
          >
            Email Activities PDF
          </DropdownItem>
          <DropdownItem
            onClick={() =>
              handleExportProgram({
                format: 'word',
                includeDraftActivities: true,
              })
            }
            $isDisabled={isLoading}
          >
            Download Draft {programLabel} {isLoading && <Spinner />}
          </DropdownItem>
        </>
      }
      dropdownButtonContents={
        <Styled.SettingsDrawerButton
          type="button"
          $isActive={false}
          aria-haspopup="dialog"
        >
          <IconMore width={20} height={20} />

          <span>More</span>
        </Styled.SettingsDrawerButton>
      }
    />
  );
};

export default ActivityBuilderDownloadDropdown;
